"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleReferenceMarkdownDirectiveDefinition = void 0;
exports.formatModuleReferenceDirective = formatModuleReferenceDirective;
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.ModuleReferenceMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['moduleRef', 'signal'],
    contentAttributeName: 'moduleRef',
    directive: 'module',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
    editorMarker: '$',
});
function formatModuleReferenceDirective({ moduleRef, signal }) {
    const head = `:${exports.ModuleReferenceMarkdownDirectiveDefinition.directive}[${(0, MarkdownDirectiveDefinition_1.escapeDirectiveContent)(moduleRef)}]`;
    if (signal === undefined || signal === null || signal === '') {
        return head;
    }
    return `${head}{signal=${(0, MarkdownDirectiveDefinition_1.quoteDirectiveAttribute)(signal)}}`;
}
//# sourceMappingURL=ModuleReference.js.map